import { map } from 'lodash';
import { assertNotNull } from '../../helpers/nullHelpers';
import { ThermostatTypeCode } from '../shared/quote-or-design-form/quoteOrDesignFormData';
import { mapUnitFormModelToQuoteDto, QuoteCreateUpdateUnitDto } from '../shared/units/createUpdateUnitDto';
import { QuoteFormModel } from './quote-form/quoteFormModel';

export type CreateUpdateQuoteCommand = {
  quote: CreateUpdateQuoteDto;
};

export type CreateUpdateQuoteDto = {
  quoteId: number | null;
  useLegacyPricingModel: boolean;
  projectId: number;
  customerId: number;
  name: string;
  isDraft: boolean;
  thermostatTypeCode: ThermostatTypeCode;
  includeNeoHub: boolean;
  units: Array<QuoteCreateUpdateUnitDto> | null;
};

export const mapQuoteFormModelToCommand = (formModel: QuoteFormModel, projectId: number): CreateUpdateQuoteCommand => ({
  quote: {
    quoteId: formModel.quoteId,
    useLegacyPricingModel: formModel.useLegacyPricingModel,
    projectId,
    customerId: assertNotNull(formModel.customerId),
    name: formModel.name,
    isDraft: formModel.isDraft,
    thermostatTypeCode: formModel.thermostatTypeCode,
    includeNeoHub: formModel.includeNeoHub,
    units: map(formModel.units, (unit, unitIndex) => mapUnitFormModelToQuoteDto(unit, unitIndex)),
  },
});
